import {
  Companion_instancecsbm5ewxyfnq as Companion_instance,
  AlwaysSharedCopyTracker_getInstance1rs3z6uqvhgfu as AlwaysSharedCopyTracker_getInstance,
} from './Segment.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SegmentPoolClass;
function SegmentPool() {
  if (SegmentPoolClass === VOID) {
    class $ {
      constructor() {
        this.c4g_1 = 0;
        this.d4g_1 = 0;
      }
      r3w() {
        return Companion_instance.f4h();
      }
      s4g(segment) {
      }
      j4h() {
        return AlwaysSharedCopyTracker_getInstance();
      }
    }
    initMetadataForObject($, 'SegmentPool');
    SegmentPoolClass = $;
  }
  return SegmentPoolClass;
}
var SegmentPool_instance;
function SegmentPool_getInstance() {
  return SegmentPool_instance;
}
//region block: init
SegmentPool_instance = new (SegmentPool())();
//endregion
//region block: exports
export {
  SegmentPool_instance as SegmentPool_instanceps1mclk6cv3l,
};
//endregion

//# sourceMappingURL=SegmentPool.mjs.map
